<ng-container *ngIf="disabled">
  <div id="disabled-field"></div>
</ng-container>

<ng-container *ngIf="!disabled">
  <div id="fake-field">
    <p *ngIf="!params.value" class="placeholder-text">{{ placeholder }}</p>
    <p *ngIf="params.value">{{ this.value }}</p>
    <mat-icon *ngIf="fieldType === 'dropdown'">expand_more</mat-icon>
    <mat-icon class="datetime" *ngIf="fieldType === 'datetime'"
      >calendar_today</mat-icon
    >
  </div>
</ng-container>
